export default __webpack_public_path__ + "static/media/structure_white.abf235a8.svg";